<script>

    import Loading from 'southcn-ui2/src/components/widgets/Loading';
    import NoData from 'southcn-ui2/src/components/widgets/NoData';
    import NormalSwitch from 'southcn-ui2/src/components/widgets/NormalSwitch';
    import NormalCascader from 'southcn-ui2/src/components/widgets/NormalCascader';
    import NormalLabel from 'southcn-ui2/src/components/widgets/NormalLabel';
    import NormalScrollbar from 'southcn-ui2/src/components/widgets/NormalScrollbar';
    import NormalButton from 'southcn-ui2/src/components/widgets/NormalButton';
    import ModalHeader from 'southcn-ui2/src/components/modals/ModalHeader';

    import draggable from 'vuedraggable';
    import AppItem from '@/components/widgets/AppItem.vue';

    export default {
        alias: 'appSetting',
        defaultOptions () {
            return {
                title: '全部应用'
            };
        },
        modalCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
            this.serviceValue = this.$util.deepCopy(this.website.serviceValue);
            this.fetchSitesApp(this.website.id);
            this.$refs.scroll.$el.querySelector('.normal-scrollbar__wrap').addEventListener('scroll', this.emitGlobalOptHide);
        },
        beforeDestroy () {
            this.$refs.scroll.$el.querySelector('.normal-scrollbar__wrap').removeEventListener('scroll', this.emitGlobalOptHide);
        },
        data () {
            return {
                canMove: false,
                title: '',
                isDrag: true,
                optionHeight: 600,
                siteId: 0,
                loading: false,
                favLoading: false,
                dropStatus: {
                    fav: true,
                    yyyy: true,
                    yxjk: true,
                    glkh: true,
                    styy: true
                },
                serviceValue: [],
                favAppList: [],
                siteAppMap: null,
                siteAppList: null,
                yyyyKeys: [
                    {
                        text: '信息公开',
                        value: 'xxgk'
                    },
                    {
                        text: '互动交流',
                        value: 'hdjl'
                    },
                    {
                        text: '解读回应',
                        value: 'jdhy'
                    }
                ],
                otherKeys: [
                    {
                        text: '运行监控',
                        value: 'yxjk'
                    },
                    {
                        text: '管理考核',
                        value: 'glkh'
                    },
                    {
                        text: '生态应用',
                        value: 'styy'
                    }
                ]
            };
        },
        name: 'modal-app-setting',
        methods: {
            emitGlobalOptHide () {
                this.$bus.$emit('global-hide-options');
            },
            onDestroy () {
                this.cancelCallback && this.cancelCallback(this.favAppList);
            },
            handleDropStatus (type) {
                this.dropStatus[type] = !this.dropStatus[type];
            },
            handleSelectSites ($e) {
                this.fetchSitesApp(this.$util.deepCopy($e).pop());
            },
            async fetchSitesApp (siteId) {
                const site = this.sites.filter(v => v.id === siteId)[0];
                if (!site) {
                    this.$alias.message.error('此站点信息不存在，请选择其他站点');
                    return;
                }
                this.loading = true;
                try {
                    const orgAppList = await this.$api(this.$config.apiUrl.orgAppList, {}, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Cur-Org-Id': siteId
                        }
                    });
                    const map = {};

                    const result = this.$util.handleOrgAppList({
                        appList: orgAppList.app_list,
                        visibleAppList: orgAppList.visible_app_list,
                        organization: site,
                        sourceApp: 'usercenter',
                        hasDisabled: true
                    });

                    result.forEach((data) => {
                        const tempValue = map[data.type] = map[data.type] || [];
                        data.is_fav = this.favAppList.some(app => {
                            return app.indexId === `index_${siteId}_${data.appId}`;
                        });
                        tempValue.push(data);
                    });

                    this.siteAppList = result;
                    this.siteAppMap = map;
                } catch (e) {
                    this.$alias.message.error(`获取应用列表失败：${e.errmessage}`);
                } finally {
                    this.loading = false;
                }
            },
            handleGoApp (app) {
                if (!app.disabled && app.link) {
                    window.open(app.link);
                }
            },
            async fetchFavApp () {
                this.favLoading = true;
                try {
                    this.favAppList = await this.$util.fetchFavList();
                    this.siteAppList.forEach(v => {
                        v.is_fav = this.favAppList.filter(app => {
                            return app.indexId === `index_${v.orgId}_${v.appId}`;
                        }).length;
                    });
                } catch (e) {
                    console.log(e);
                    this.$alias.message.error(`获取常用应用列表失败：${e.errmessage}`);
                } finally {
                    this.favLoading = false;
                }
            },
            async handleFavApp (app) {
                const text = app.is_fav ? '取消常用应用' : '添加常用应用';
                try {
                    await this.$api(this.$config.apiUrl.orgFavToggle, {
                        org_id: app.orgId,
                        app_id: app.appId,
                        is_fav: Number(!app.is_fav)
                    });
                    app.is_fav = !app.is_fav;
                    this.$alias.message.ok(`${text}成功`);
                    await this.fetchFavApp();
                    const curSite = this.serviceValue[this.serviceValue.length - 1];
                    if (app.orgId === curSite) {
                        await this.fetchSitesApp(curSite);
                    }

                } catch (e) {
                    console.log(e);
                    this.$alias.message.error(`${text}失败：${e.errmessage}`);
                }
            },
            async handleSortFavApp () {
                const text = '移动常用应用';
                try {
                    const ids = this.favAppList.map(v => v.favAppId).join(',');
                    await this.$api(this.$config.apiUrl.orgFavSort, {ids});
                    this.$alias.message.ok(`${text}成功`);
                } catch (e) {
                    this.$alias.message.error(`${text}失败：${e.errmessage}`);
                }
            },
        },
        components: {
            NoData,
            ModalHeader,
            NormalButton,
            NormalLabel,
            NormalScrollbar,
            AppItem,
            NormalCascader,
            Loading,
            draggable,
            NormalSwitch
        },
        computed: {
            compYyyyKeys () {
                const keys = ['xxgk', 'hdjl', 'jdhy'];
                const {appConfig} = this.$store.state;
                if (appConfig.topbar_app_group_textmap) {
                    return appConfig.topbar_app_group_textmap.split(',').map((v) => {
                        const [, value, text] = v.split('|');
                        if (keys.includes(value)) {
                            return {
                                text, value
                            };
                        }
                    }).filter(v => v);
                }
                return this.yyyyKeys;
            },
            compOtherKeys () {
                const keys = ['yxjk', 'glkh', 'styy'];
                const {appConfig} = this.$store.state;
                if (appConfig.topbar_app_group_textmap) {
                    return appConfig.topbar_app_group_textmap.split(',').map((v) => {
                        const [, value, text] = v.split('|');
                        if (keys.includes(value)) {
                            return {
                                text, value
                            };
                        }
                    }).filter(v => v);
                }
                return this.otherKeys;
            },
            serviceList () {
                return this.$store.state.serviceList;
            },
            sites () {
                return this.$store.state.sites;
            },
            website () {
                return this.$store.state.website;
            },
            user () {
                return this.$store.state.user;
            },
            dragOptions () {
                return {
                    disabled: !this.canMove
                };
            }
        },
        mounted () {
        }
    };
</script>

<template>
    <div class="modal">
        <modal-header :text="title" :is-drag="true" @close="onDestroy"></modal-header>
        <normal-scrollbar ref="scroll" :height="optionHeight">
            <div class="modal-content">
                <div class="fav-app-list">
                    <div class="row">
                        <normal-label @click.native.capture="handleDropStatus('fav')"
                                      :suffix-icon="dropStatus.fav ? '&#xe699;' : '&#xe69b;'">常用应用
                        </normal-label>
                        <normal-switch theme="slim"
                                       :disabled="!favAppList.length"
                                       v-model="canMove"></normal-switch>
                        <normal-label float="right"
                                      :marginRight="1"
                        >应用排序：
                        </normal-label>
                    </div>
                    <div class="app-wrapper with-drag" v-show="dropStatus.fav">
                        <draggable v-model="favAppList"
                                   v-bind="dragOptions"
                                   @change="handleSortFavApp">
                            <app-item :img="app.img"
                                      :link="app.link"
                                      :name="app.org_name"
                                      :disabled="app.disabled"
                                      v-for="app in favAppList"
                                      class="fav-item"
                                      @app-fav-click="handleFavApp(app)"
                                      :status="app.is_fav"
                                      :class="{'can-move':canMove}"
                                      theme="modal-theme"
                                      :key="app.indexId"
                                      :app="app.name"></app-item>
                            <no-data theme="sm" :visible="!favAppList.length"/>
                        </draggable>
                        <Loading :visible="favLoading"/>
                    </div>
                </div>
                <div class="row x1 site-select-row">
                    <normal-cascader :withSearch="true"
                                     class="site-select"
                                     float="none"
                                     :with-tool-tip="true"
                                     :options="serviceList"
                                     @select="handleSelectSites"
                                     v-model="serviceValue"
                    ></normal-cascader>
                </div>
                <div class="user-sites-app-list">
                    <Loading :visible="loading"/>
                    <template v-if="siteAppMap">
                        <div class="row">
                            <normal-label @click.native.capture="handleDropStatus('yyyy')"
                                          :suffix-icon="dropStatus.yyyy ? '&#xe699;' : '&#xe69b;'">运营应用
                            </normal-label>
                        </div>
                        <template>
                            <div class="app-wrapper"
                                 v-show="dropStatus.yyyy"
                                 v-for="(item) in compYyyyKeys"
                                 :key="item.value">
                                <div class="row yyyy-tips">
                                    <span>{{item.text}}</span>
                                </div>
                                <div>
                                    <app-item :img="app.img"
                                              :link="app.link"
                                              v-for="(app,key) in siteAppMap[item.value]"
                                              :disabled="app.disabled"
                                              class="site-app-item"
                                              :status="app.is_fav"
                                              theme="modal-theme"
                                              @app-fav-click="handleFavApp(app)"
                                              :key="`${item.value}_${key}`"
                                              :app="app.group_name"></app-item>
                                </div>
                            </div>
                        </template>

                        <template v-for="item in compOtherKeys">
                            <div class="row" :key="`row_${item.value}`">
                                <normal-label @click.native.capture="handleDropStatus(item.value)"
                                              :suffix-icon="dropStatus[item.value] ? '&#xe699;' : '&#xe69b;'">
                                    {{item.text}}
                                </normal-label>
                            </div>
                            <div class="app-wrapper" :key="`wrapper_${item.value}`" v-show="dropStatus[item.value]">
                                <app-item :img="app.img"
                                          :link="app.link"
                                          v-for="(app,key) in siteAppMap[item.value]"
                                          class="site-app-item"
                                          :disabled="app.disabled"
                                          :status="app.is_fav"
                                          @app-fav-click="handleFavApp(app)"
                                          theme="modal-theme"
                                          :key="`${item.value}_${key}`"
                                          :app="app.group_name"></app-item>
                            </div>
                        </template>
                    </template>
                </div>
            </div>
        </normal-scrollbar>
    </div>
</template>

<style lang="less" scoped>
    @import '../../../southcn-ui2/src/assets/less/widgets-var.less';

    .modal {
        .modal-style;
        position: absolute;
        min-height: 210px;
        width: 780px;
        padding-bottom: 0;
        margin-bottom: 20px;

        a {
            text-decoration: none;
        }

        .modal-content {
            box-sizing: border-box;
            padding: 23px 29px;

            .fav-app-list {
                position: relative;
                overflow: hidden;

                .app-wrapper {
                    position: relative;
                    min-height: 130px;

                    &.with-drag {
                        > div {
                            overflow: hidden;
                        }
                    }
                }

                .switch-box {
                    float: right;
                }
            }

            .user-sites-app-list {
                position: relative;
                min-height: 180px;

                .yyyy-tips {
                    margin-bottom: 10px;

                    span {
                        color: @otherTextClr;
                        font-size: @fontSizeeBtnTableText;
                    }
                }
            }

            .site-select-row {
                position: relative;
                text-align: center;


                .site-select {
                    display: inline-block;
                    max-width: 450px!important;
                }

                &:after, &:before {
                    content: '';
                    position: absolute;
                    top: 50%;
                    margin-top: -.5px;
                    width: 100px;
                    height: 1px;
                    background-color: @otherBorderClr;
                    left: 0;
                }

                &:after {
                    right: 0;
                    left: unset;
                }
            }

            .label {
                margin-top: 0;
                font-size: @fontSizeTableTitle;
            }


            .fav-item, .site-app-item {
                margin-right: 19px;
                margin-bottom: 17px;

                &:nth-child(3n) {
                    margin-right: 0;
                }
            }
        }


    }
</style>
